import { sleep } from '@flowus/common/async';
import type { NextBlock } from '@flowus/common/block/type';
import { cx } from '@flowus/common/cx';
import { fetchSubscribeInfo } from '@flowus/common/subscribe';
import type { SubscribeInfo } from '@flowus/common/subscribe/type';
import { useLocalStorageState } from 'ahooks';
import { sampleSize } from 'lodash-es';
import { useEffect, useState, type FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { publicLink } from 'src/common/const';
import { LocalStorageKey } from 'src/const/local-storage-state-key';
import { useFetchPage } from 'src/hooks/page';
import { ID_TOC_CONTAINER } from 'src/hooks/page/use-dnd/helper';
import { blocksActions } from 'src/redux/reducers/blocks';
import { collectionViewsActions } from 'src/redux/reducers/collection-views';
import { dispatch } from 'src/redux/store';
import { useSubscribePages } from 'src/services/app';
import { bizTracker } from 'src/utils/biz-tracker';
import { TocGroupHeader } from '../toc/toc-group-header';
import { TocItem } from '../toc/toc-item';
import { TocType } from '../toc/types';

/** 订阅toc */
export const SubscribeToc: FC = () => {
  const tocItems = useSubscribePages();
  const [subscribeInfo, setSubscribeInfo] = useState<SubscribeInfo[]>();
  const fetchPage = useFetchPage();

  // 精选关闭
  const [subscribeHidden, setSubscribeHidden] = useLocalStorageState(
    LocalStorageKey.SUBSCRIBE_HIDDEN,
    { defaultValue: false }
  );

  const [showAnimate, setShowAnimate] = useState(false);

  useEffect(() => {
    void fetchSubscribeInfo((data) => {
      const { blocks, collectionViews } = data;
      if (collectionViews) {
        dispatch(collectionViewsActions.update(collectionViews));
      }
      dispatch(blocksActions.update({ blocks: blocks as Record<string, NextBlock> }));
    }).then((res) => {
      const finalResult: SubscribeInfo[] = [];
      res?.forEach((r) => {
        r.subscribeInfo?.forEach((a) => {
          a.isRecommend && finalResult.push(a);
        });
      });
      const ret = sampleSize(finalResult, 5);
      ret.forEach((a) => {
        void fetchPage(a.id ?? '');
      });
      setSubscribeInfo(ret);
    });
  }, [fetchPage]);
  if (!tocItems) return null;

  return (
    <div id={ID_TOC_CONTAINER} className="h-full min-h-17.5 overflow-y-auto pb-10 space-y-2">
      <TocGroupHeader
        showCreateButton={false}
        type={TocType.PRIVATE}
        tooltipDesc="我订阅的页面"
        title="我的订阅"
        addonAfter={
          !__BUILD_IN__ && (
            <a
              href={publicLink.subscribeCenter}
              target="_blank"
              className="flex underline underline-offset-2 items-center animate-hover px-1 mr-3 animate-click space-x-1 text-t4"
              onClick={() => {
                bizTracker.event('knowledge', { is_from: 'up_to_knowledge' });
              }}
            >
              <span>去知识库订阅</span>
              <Icon name="IcJumpTo" size="middle" />
            </a>
          )
        }
      >
        {tocItems.map((tocId, index) => {
          return <TocItem key={index} uuid={tocId} deep={0} />;
        })}
        {!tocItems.length && (
          <div className="text-t4 space-y-2 text-grey3 text-center flex items-center justify-center flex-col py-4">
            <Icon name="IcSubscribe" size="middle" />
            <span>暂无内容，快去知识库订阅吧～</span>
          </div>
        )}
      </TocGroupHeader>
      {!subscribeHidden && (
        <div
          className={cx(
            'relative bg-aside rounded',
            showAnimate && 'animate__animated animate__backOutDown'
          )}
        >
          <TocGroupHeader
            showCreateButton={false}
            type={TocType.RECOMMEND}
            tooltipDesc="精选栏目推荐"
            title="精选栏目推荐"
            addonAfter={
              <Icon
                className="mr-4"
                name={'IcToastClose'}
                size="small"
                onClick={async () => {
                  setShowAnimate(true);
                  await sleep(1000);
                  setSubscribeHidden(true);
                }}
              />
            }
          >
            {subscribeInfo?.map((info, index) => {
              return <TocItem key={index} uuid={info.id} deep={0} />;
            })}
            {!subscribeInfo?.length && (
              <div className="text-t4 space-y-2 text-grey3 text-center">
                <span>暂无内容，去知识库看看吧～</span>
              </div>
            )}
          </TocGroupHeader>
        </div>
      )}
      {/* <div
        className="hidden cursor-pointer hover:bg-black_006 animate-click border-t w-full text-center text-t2-medium py-3"
        onClick={() => {
          openModal.warning;
          openModal.modal({
            content: ({ onCloseModal }) => (
              <div className="next-modal p-5 w-[400px]">
                <div className="text-left text-t2">
                  <div>申请退款前，请先阅读以下说明：</div>
                  <div className="mt-4">1.为了保障你和创作者的权益，可在购买后48小时内申请退款</div>
                  <div className="mt-0.5">
                    <div>2.如需退款，需提供两个信息：</div>
                    <div>- 订单截图，要确保能看见订单号</div>
                    <div>- 退款原因</div>
                  </div>
                  <div className="mt-0.5">3.非实时处理，我们会在48小时内审核，请耐心等待。</div>
                  <div className="mt-4">如确认退款，请填写退款申请表</div>
                </div>
                <div className="flex mt-6 justify-end">
                  <Button className="flex-1" colorType="secondary" onClick={() => onCloseModal()}>
                    关闭
                  </Button>
                  <Button
                    className="flex-1 ml-2.5"
                    colorType="active"
                    onClick={() => {
                      window.open('https://flowus.cn/form/275fa97c-46be-4f5c-8d51-12fb2f8650eb');
                    }}
                  >
                    填写退款申请表
                  </Button>
                </div>
              </div>
            ),
          });
        }}
      >
        申请退款
      </div> */}
    </div>
  );
};
